<template>
  <div
    class="input-icon-group"
    :class="{
      'has-prepend': hasPrepend,
      'has-append': hasAppend,
      'is-valid': isValid,
      'is-invalid': isInvalid,
    }"
  >
    <slot name="default"></slot>

    <div v-if="hasPrepend" class="input-icon-prepend">
      <slot name="prepend"></slot>
    </div>

    <div v-if="hasAppend" class="input-icon-append">
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputIconGroup',

  props: {
    state: {
      type: Boolean,
      default: null,
    },
  },

  computed: {
    hasPrepend() {
      return this.$slots.prepend;
    },
    hasAppend() {
      return this.$slots.append;
    },

    isValid() {
      return this.state === true;
    },
    isInvalid() {
      return this.state === false;
    },
  },
};
</script>
